import { RetailProductApiResponse } from '../types/retail-product';
import { ReviewApiResponse } from '../types/review';
import HttpHelpers from './helpers';
import formatResponse from './utils';

const RetailProductsApiEndpoints = {
  getRetailProducts: (): Promise<RetailProductApiResponse> => HttpHelpers.unAuthenticatedAxios
    .get<RetailProductApiResponse>('/api/v1/retail_products')
    .then((response) => response.data),
  getRetailProductBySlug: (slug: string) => HttpHelpers.unAuthenticatedAxios
    .get(`/api/v1/retail_products/${slug}`)
    .then((response) => response.data),
  getRetailProductReviews: (id: string, page: number, perPage: number): Promise<ReviewApiResponse> => HttpHelpers.unAuthenticatedAxios
    .get(`/api/v1/retail_products/${id}/reviews`, {
      params: {
        page: {
          number: page,
          size: perPage,
        },
      },
    })
    .then((response) => formatResponse(response.data)),
  createRetailProductReview: (
    id: string,
    data: {
      rating: number;
      description?: string | null;
      is_anonymous: boolean;
    },
  ): Promise<ReviewApiResponse> => HttpHelpers.authenticatedAxios
    .post(`/api/v1/retail_products/${id}/reviews`, data)
    .then((response) => formatResponse(response.data)),
};

export default RetailProductsApiEndpoints;
